import { Banner as BannerType } from 'app/blocks/banner'
import React from 'react'
import { AdFullWidth } from './Ad/AdFullWidth'
import { AdGrid } from './Ad/AdGrid'
import { AdCustomColour } from './Ad/AdCustomColour'
import { AdRainbow } from './Ad/AdRainbow'
import { AdStandard } from './Ad/AdStandard'

interface Props {
  block: BannerType
  paddedX?: boolean
}

export const BannerBlock: React.FC<Props> = ({ block, paddedX }) => {
  const variation = block.theme || 'default'
  const bannerImage = block?.image?.url || ''
  const secondaryBannerImage = block?.secondaryImage?.url || ''

  if (variation === 'default') {
    return (
      <AdStandard
        title={block.title}
        richTextDescription={block.description}
        image={bannerImage}
        ctaLabel={block.ctaLabel}
        href={block.href}
        reverse={block.reverse}
        paddedX={paddedX}
      />
    )
  }

  if (variation === 'fullWidthHover') {
    return (
      <AdFullWidth
        image={bannerImage}
        ctaLabel={block.ctaLabel}
        href={block.href}
      />
    )
  }

  if (variation === 'sideBySide') {
    const items = [
      {
        title: block.title,
        richTextDescription: block.description,
        image: bannerImage,
        ctaLabel: block.ctaLabel,
        href: block.href,
      },
      {
        title: block.secondaryTitle,
        richTextDescription: block.secondaryDescription,
        image: secondaryBannerImage,
        ctaLabel: block.secondaryCtaLabel,
        href: block.secondaryHref,
      },
    ]

    return <AdGrid items={items} paddedX={paddedX} />
  }

  if (variation === 'rainbow') {
    return (
      <AdRainbow
        image={bannerImage}
        title={block.title}
        richTextDescription={block.description}
        ctaLabel={block.ctaLabel}
        href={block.href}
        paddedX={paddedX}
        backgroundPattern={block.backgroundPattern}
      />
    )
  }

  if (variation === 'customColour') {
    return (
      <AdCustomColour
        image={bannerImage}
        title={block.title}
        richTextDescription={block.description}
        ctaLabel={block.ctaLabel}
        href={block.href}
        backgroundColour={block.bannerBackgroundColour ?? block.backgroundColour}
        foregroundColour={block.bannerForegroundColour ?? block.foregroundColour}
        paddedX={paddedX}
        backgroundPattern={block.backgroundPattern}
      />
    )
  }

  return null
}
